<template>

  <t-page>

    <t-page-form multi-cards :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #title-buttons>

        <t-button v-if="pageFormIsLoaded && form.modelActivity.enableCopyLastActivity && !isDelete()"
                  @click="confirmCopyLastActivity()">Copiar última atividade
        </t-button>

      </template>

      <template #default="{status}">

        <t-input v-model="form['activity'+activityNumber+'Id']" hidden/>

        <t-form-card title="Dados Inspeção">

          <b-row>

            <t-input v-model="form['activity'+activityNumber+'Number']"
                     lpad="4"
                     cols="4"
                     label="Cód. Atividade"
                     fixed
                     highlight/>

            <t-input cols="4" v-model="form.checklist.issueDate" date fixed label="Data Inspeção" required/>

            <t-input cols="4" v-model="form.checklist.inspector" fixed label="Inspetor"/>

          </b-row>

          <b-row>

            <t-input cols="3" v-model="form.checklist.enterpriseCodeLabel" fixed label="Cód. Empr."/>

            <t-input cols="9" v-model="form.checklist.enterprise" fixed label="Empreendimento"/>

          </b-row>

        </t-form-card>

        <t-form-card title="Formulário">

          <!--ATENÇÃO NÃO ESQUECER DE UTILIZAR template #default="{status} para funcionamento correto-->
          <t-page-form-field-customized
              ref="fieldsGeneral"
              :command="command" :status="status" :user-auth="userAuth"
              :fields-customizable="entityFieldCustomized('page')"
              :primary-key="form['activity'+activityNumber+'Id']" :foreign-key="currentPage.pageId"
              :busy="!pageFormIsLoaded"
              :primary-key-column="fieldKey" foreign-key-column="pageId"
          />

          <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        </t-form-card>

      </template>

      <template #out-of-form>

        <t-form-card v-if="form.modelActivity.enableChild" :title="form.typeActivity.titleChild">

          <ChecklistActivityFormChildEmbeddable
              :activity-number="activityNumber"
              :foreign-key="form['activity'+activityNumber+'Id']"
              :checklist-id="form.checklistId" />

        </t-form-card>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ChecklistActivityFormChildEmbeddable from "@/views/modules/checklist/ChecklistActivity/embeddable/ChecklistActivityFormChildEmbeddable";
import ui from "@/assets/scripts/ui";
import ChecklistModelActivityService from "@/services/modules/checklist/ChecklistModelActivity.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  components: {ChecklistActivityFormChildEmbeddable},
  name: 'ChecklistActivityFormEmbeddable',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: true,
      fieldKey: "activity" + this.activityNumber + "Id",
      form: {
        ["activity" + this.activityNumber + "Id"]: 0,
        ["activity" + this.activityNumber + "Number"]: 0,
        checklistId: 0,
        note: "",
        status: 1,
        typeActivityId: 0,
        typeChecklistId: 0,
        enterpriseId: 0,
        typeChecklistActivity: "",
        checklist: {},
        modelActivity: {},
        typeActivity: {},
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    activityNumber: Number,
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    confirmCopyLastActivity() {

      ui.msgConfirm(this, 'Atenção', 'Deseja realizar a cópia dos dados da última atividade preenchida para o mesmo local?<br /><br />Atenção caso o sistema encontrar, irá sobrepor as informações atuais.', async () => {

        await ChecklistModelActivityService.copyData(this.form.checklistActivityId).then(async() => {

          ui.toast(this,'Informação','Copia dos dados da última atividade realizada com sucesso!')

          await this.mountedForm(true, false)


        }).catch(error => this.responseError(error))

      })

    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

